import type { Part } from './Part';

export const PART_CATALOG: Part[] = [
  // Capsule
  {
    id: 'capsule_mk1',
    name: 'MK-1 Capsule',
    kind: 'capsule',
    size: 'M',
    mass: 1200,
    crewCapacity: 1,
    hasParachute: true,
    dragCoeff: 0.5
  },
  // Tanks
  {
    id: 'tank_s_lfo',
    name: 'Tank S · 5 t',
    kind: 'tank',
    size: 'S',
    mass: 200,
    fuelCapacity: 5000,
    fuelType: 'LFO',
    dragCoeff: 0.4
  },
  {
    id: 'tank_m_lfo',
    name: 'Fuel Tank M (LFO)',
    kind: 'tank',
    size: 'M',
    mass: 600,
    fuelCapacity: 50000,
    fuelType: 'LFO',
    dragCoeff: 0.4
  },
  {
    id: 'tank_l_lfo',
    name: 'Fuel Tank L (LFO)',
    kind: 'tank',
    size: 'L',
    mass: 1200,
    fuelCapacity: 100000,
    fuelType: 'LFO',
    dragCoeff: 0.4
  },
  {
    id: 'tank_xl_lfo',
    name: 'Tank XL · 250 t',
    kind: 'tank',
    size: 'XL',
    mass: 2500,
    fuelCapacity: 250000,
    fuelType: 'LFO',
    dragCoeff: 0.4
  },
  // Engines
  {
    id: 'engine_ant',
    name: '"Ant" Engine',
    kind: 'engine',
    size: 'S',
    mass: 50,
    // Tuned for a lively but controllable starter: about 5.7 TWR with the
    // default two-tank stack on the enlarged Earth.
    thrust: 930.0,
    isp: 350,
    fuelType: 'LFO'
  },
  {
    id: 'engine_sparkler',
    name: '"Sparkler" Vac Engine',
    kind: 'engine',
    size: 'S',
    mass: 80,
    thrust: 134.4,
    isp: 385,
    fuelType: 'LFO'
  },
  {
    id: 'engine_vector',
    name: '"Vector" Engine',
    kind: 'engine',
    size: 'M',
    mass: 400,
    thrust: 3024.0,
    isp: 340,
    fuelType: 'LFO'
  },
  {
    id: 'engine_reliant',
    name: '"Reliant" Engine',
    kind: 'engine',
    size: 'M',
    mass: 300,
    thrust: 3024.0,
    isp: 290,
    fuelType: 'LFO'
  },
  {
    id: 'engine_mastodon',
    name: '"Mastodon" Engine',
    kind: 'engine',
    size: 'L',
    mass: 1200,
    thrust: 6300.0,
    isp: 330,
    fuelType: 'LFO'
  },
  {
    id: 'engine_poodle',
    name: '"Poodle" Vac Engine',
    kind: 'engine',
    size: 'L',
    mass: 900,
    thrust: 2016,
    isp: 370,
    fuelType: 'LFO'
  },
  {
    id: 'engine_twinboar',
    name: '"TwinBoar" Booster',
    kind: 'engine',
    size: 'L',
    mass: 1800,
    thrust: 11340.0,
    isp: 300,
    fuelType: 'LFO'
  },
  {
    id: 'engine_mammoth',
    name: '"Mammoth" Engine',
    kind: 'engine',
    size: 'XL',
    mass: 3000,
    thrust: 13860.0,
    isp: 310,
    fuelType: 'LFO'
  },
  {
    id: 'engine_kickback',
    name: '"Kickback" Heavy Booster',
    kind: 'engine',
    size: 'XL',
    mass: 4500,
    thrust: 17640.0,
    isp: 280,
    fuelType: 'LFO'
  },
  // Parachute (separate part that attaches to capsule)
  {
    id: 'parachute_mk16',
    name: 'Mk-16 Parachute',
    kind: 'parachute',
    size: 'M',
    mass: 30,
    dragCoeff: 5.0
  },
  // Landing legs
  {
    id: 'legs_landini',
    name: '"Landini" Landing Legs',
    kind: 'legs',
    size: 'S',
    mass: 80,
    dragCoeff: 0.1
  },
  // Heat shields
  {
    id: 'heatshield_s',
    name: 'Heat Shield S (Ablative)',
    kind: 'heatshield',
    size: 'S',
    mass: 50,
    heatCapacity: 50000,
    dragCoeff: 1.2
  },
  {
    id: 'heatshield_m',
    name: 'Heat Shield M (Ablative)',
    kind: 'heatshield',
    size: 'M',
    mass: 150,
    heatCapacity: 150000,
    dragCoeff: 1.2
  },
  {
    id: 'heatshield_l',
    name: 'Heat Shield L (Ablative)',
    kind: 'heatshield',
    size: 'L',
    mass: 400,
    heatCapacity: 400000,
    dragCoeff: 1.2
  },
  // Decoupler
  {
    id: 'decoupler_1',
    name: 'TD-1 Decoupler',
    kind: 'decoupler',
    size: 'M',
    mass: 100,
    dragCoeff: 0.3
  },
  {
    id: 'decoupler_s',
    name: 'TD-0 Decoupler (S)',
    kind: 'decoupler',
    size: 'S',
    mass: 40,
    dragCoeff: 0.3
  },
  {
    id: 'decoupler_l',
    name: 'TD-2 Decoupler (L)',
    kind: 'decoupler',
    size: 'L',
    mass: 250,
    dragCoeff: 0.3
  },
  // Fairings (aerodynamic nose cones — reduce drag in atmosphere)
  {
    id: 'fairing_s',
    name: 'Nose Cone S',
    kind: 'fairing',
    size: 'S',
    mass: 20,
    dragCoeff: 0.1
  },
  {
    id: 'fairing_m',
    name: 'Nose Cone M',
    kind: 'fairing',
    size: 'M',
    mass: 50,
    dragCoeff: 0.1
  },
  {
    id: 'fairing_l',
    name: 'Payload Fairing L',
    kind: 'fairing',
    size: 'L',
    mass: 120,
    dragCoeff: 0.1
  },
  // RCS thruster block (small attitude control)
  {
    id: 'rcs_block',
    name: 'RCS Thruster Block',
    kind: 'rcs',
    size: 'S',
    mass: 10,
    thrust: 22.4,
    isp: 240,
    fuelType: 'LFO',
    dragCoeff: 0.05
  },
  // Solar panel (decorative + future power)
  {
    id: 'solar_panel',
    name: 'Solar Panel',
    kind: 'solar',
    size: 'S',
    mass: 25,
    dragCoeff: 0.2
  },

];

// Retain old IDs and dimensions for saved rockets; only this smaller set is offered for new builds.
const addedParts: Part[] = [
  {id:'tank_s_dense',name:'Tank S · 10 t',kind:'tank',size:'S',mass:200,fuelCapacity:10000,fuelType:'LFO',dragCoeff:.4,tankStyle:'ribbed'},
  {id:'tank_xl_dense',name:'Tank XL · 500 t',kind:'tank',size:'XL',mass:2500,fuelCapacity:500000,fuelType:'LFO',dragCoeff:.4,tankStyle:'ribbed'},
  {id:'capsule_s',name:'Capsule S',kind:'capsule',size:'S',mass:1200,crewCapacity:1,hasParachute:true,dragCoeff:.5},
  {id:'capsule_xl',name:'Capsule XL',kind:'capsule',size:'XL',mass:6000,crewCapacity:3,hasParachute:true,dragCoeff:.5},
  {id:'decoupler_xl',name:'Decoupler XL',kind:'decoupler',size:'XL',mass:400,dragCoeff:.3},
  {id:'legs_xl',name:'Landing Legs XL',kind:'legs',size:'XL',mass:400,dragCoeff:.1},
  {id:'heatshield_xl',name:'Heat Shield XL',kind:'heatshield',size:'XL',mass:800,heatCapacity:800000,dragCoeff:1.2},
  {id:'fairing_xl',name:'Nose Cone XL',kind:'fairing',size:'XL',mass:180,dragCoeff:.1},
];
PART_CATALOG.push(...addedParts);

export const ASSEMBLY_PARTS: Part[] = [
  'capsule_s','capsule_xl',
  'tank_s_lfo','tank_s_dense','tank_xl_lfo','tank_xl_dense',
  'engine_ant','engine_mammoth',
  'decoupler_s','decoupler_xl',
  'legs_landini','legs_xl',
  'heatshield_s','heatshield_xl',
  'fairing_s','fairing_xl',
].map(id => PART_CATALOG.find(p => p.id === id)!);

export function findPart(id: string): Part | undefined {
  return PART_CATALOG.find((p) => p.id === id);
}
